declare const window: Window &
  typeof globalThis & {
    APP_CONFIG: any;
  };

export const APP_Config = () => window?.APP_CONFIG;
